import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Logo = ({ className = "" }) => {
  return (
    <Link 
      to="/" 
      className={`flex items-center gap-2 group ${className}`}
      data-testid="logo-link"
    >
      <div className="relative">
        <Heart 
          className="w-8 h-8 text-[#E8A0BF] fill-[#E8A0BF] group-hover:scale-110 transition-transform duration-300" 
        />
        <div className="absolute inset-0 bg-[#E8A0BF] blur-lg opacity-30 group-hover:opacity-50 transition-opacity" />
      </div>
      <span 
        className="text-2xl font-bold tracking-tight"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        <span className="text-[#2D2D2D]">Lo</span>
        <span className="text-[#E8A0BF]">Be</span>
      </span>
    </Link>
  );
};

export default Logo;
